import { Controller } from "stimulus";

export default class extends Controller {
  click(event) {
    $("#modal-to-halloboer a").attr('href', this.element.href);
    $("#modal-to-halloboer").modal();
    event.preventDefault();
  }
}
